import type { SelectProps } from 'antd/es/select';

export const defaultFilterOptions: SelectProps<unknown>['filterOption'] = (
  input,
  option,
) => {
  const terms = input.toLowerCase().split(/[\s,]+/);
  return terms.every((term) =>
    typeof option?.label === 'string' ?
      option?.label?.toLowerCase().includes(term)
    : false,
  );
};

export const valueLabelFilterOptions: SelectProps<unknown>['filterOption'] = (
  input,
  option,
) => {
  const terms = input.toLowerCase().split(/[\s,]+/);
  return (
    terms.every((term) =>
      typeof option?.label === 'string' ?
        option?.label?.toLowerCase().includes(term)
      : false,
    ) || option?.value === input
  );
};
